import React from 'react';
import ThreeSlotRulesSection from "./ThreeSlotRulesSection";

const ThreeSlotWorking = ({ lotteryData }) => {
  return <ThreeSlotRulesSection lotteryData={lotteryData} />;
};

export default ThreeSlotWorking;
